import { gql } from 'graphql-request';

export const QUERY_PROPERTY_STATE_UPSELL = gql`
  query PropertyStateUpsell($cerberusInput: CerberusInput!) {
    # HC CAPABILITY: platform-search-experience
    # HC CAPABILITY: pexp-product-access
    # HC CAPABILITY: aexp-product-access
    # HC CAPABILITY: market-insights-product-access
    lookup(id: $cerberusInput) {
      propertyDetails {
        hcAddressId
      }
      value {
        value {
          quality
        }
        rental {
          quality
        }
      }
      mlsCoverage {
        covered
      }
      complexFields {
        sale {
          eventHistory {
            date
          }
        }
        rental {
          eventHistory {
            date
          }
        }
      }
      listings {
        entityId
        id {
          discovery {
            hcMlsId
            listingId
          }
        }
        listingDetails {
          hc {
            status
            rentalListing
            currentStatusDate
          }
        }
        media {
          hc {
            images {
              order
            }
          }
        }
      }
    }
  }
`;
